export default __webpack_public_path__ + "static/media/ankleHop.f43f5d00.png";